/**
 * Centralized post-login landing route by role, with an optional
 * commerce_model dimension for the seller path.
 *
 * Routing rules:
 *   - primary_owner / owner → /command-center
 *   - agent                 → /admin-dashboard
 *   - user (seller)         → model-aware dashboard
 *       cod / null / unknown → /dashboard
 *       dropshipping         → /dropship/dashboard
 *       digital              → /digital/dashboard
 *       hybrid               → /dashboard
 */
import type { CommerceModel } from "@/lib/commerce-model";

export type PostLoginRole =
  | "primary_owner"
  | "owner"
  | "agent"
  | "user"
  | string
  | null
  | undefined;

export function getPostLoginRedirect(
  role: PostLoginRole,
  commerceModel?: CommerceModel | null,
): string {
  if (role === "primary_owner" || role === "owner") return "/command-center";
  if (role === "agent") return "/admin-dashboard";

  switch (commerceModel) {
    case "dropshipping":
      return "/dropship/dashboard";
    case "digital":
      return "/digital/dashboard";
    case "hybrid":
    case "cod":
    default:
      return "/dashboard";
  }
}
